import { LitElement, html, css } from 'lit';

class BouncingEllipsis extends LitElement {
  static get properties() {
    return {
      interval: { type: Number },
    };
  }

  static styles = css`
    :host {
      --interval: 1000ms;
      --delay: calc(var(--interval) / 5);
      display: inline-block;
    }

    span {
      position: relative;
      font-size: inherit;
      font-weight: inherit;
      font-family: inherit;
      display: inline-block;
      color: inherit;
      animation: bounce var(--interval) infinite;
      vertical-align: middle;
    }

    span + span {
      animation-delay: calc(var(--delay) * 1);
    }

    span + span + span {
      animation-delay: calc(var(--delay) * 2);
    }

    span + span + span + span {
      animation-delay: calc(var(--delay) * 3);
    }

    @keyframes bounce {
      0% {
        transform: translateY(0);
      }
      15% {
        transform: translateY(-33%) scaleX(0.8);
      }
      40% {
        transform: translateY(10%);
      }
      60% {
        transform: translateY(0);
      }
      100% {
        transform: translateY(0);
      }
    }
  `;

  constructor() {
    super();
    if (this.interval) {
      this.style.setProperty('--interval', this.interval);
    }
    this.render();
  }

  render() {
    return html`<span>.</span><span>.</span><span>.</span>`;
  }
}

window.customElements.get('bouncing-ellipsis') ||
  window.customElements.define('bouncing-ellipsis', BouncingEllipsis);
